export const tr = {
    'button-text': 'Fiyat teklifi '
};
